module.exports = __webpack_public_path__ + "img/pumping-activities-role7.719d260e.png";